import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

export function initMainPlayersSliders() {
    let swipers = $(".main-players-slider");
    swipers.each(function () {
        let swiper = new Swiper(this, {
            speed: 900,
            preloadImages: false,
            spaceBetween: 32,
            allowTouchMove: true,
            slidesPerView: "auto",
            pagination: {
                el: ".main-players-slider-pagination",
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: ".main-players-swiper-next",
                prevEl: ".main-players-swiper-prev",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 32,
                },
            },
        });
    });
}